import { useContext, useMemo, useState } from "react";
import { Dataset, DatasetFieldLabels } from "../../../api/Datasets";
import { DateTimeRenderer } from "../../../common/datetime/DateTimeFormatter";
import { Skeleton } from "../../../common/loaders/Skeleton/Skeleton";
import { Table } from "../../../common/panels/Detail/DetailTable";
import { Tile } from "../../../common/panels/Tile/Tile";
import { Content, ContentTable } from "../../../common/tables/ContentTable/ContentTable";
import { DatasetContext } from "../../Dataset";
import styles from "./Details.module.css";
import { NotSet } from "../../../common/misc/UIconstants";
import { GetProjects } from "../../../common/misc/EntityRenders/EntityRenderer";
import {
  CustomTypeRenderer,
  CustomTypeMinimalRenderer,
  CustomTypePropertyRenderer,
} from "../../../Customization/CustomTypes/generics/CustomTypeRenderer";
interface Props {
  dataset: Dataset;
  tile?: boolean;
}
export const Details = ({ dataset, tile = true }: Props) => {
  const context = useContext(DatasetContext);
  const [mapping, setMapping] = useState<Content>([]);
  const [loading, setLoading] = useState(true);

  // Set the mapping for the ContentTable items
  useMemo(() => {
    let mapping: Content = [];
    if (dataset) {
      mapping.push(
        {
          key: DatasetFieldLabels.name,
          value: (
            <div className={"container_label"}>
              <div className={"container_label_name"} style={{ fontWeight: 600 }}>
                {dataset.name ?? NotSet}
              </div>
              <div className={"container_label_id"}>
                <span style={{ whiteSpace: "nowrap" }}>Dataset-ID: {dataset.id}</span>
              </div>
            </div>
          ),
        },
        {
          key: "Dataset type",
          value: (
            <div className={"container_label"}>
              {context?.viewShared ? (
                <CustomTypePropertyRenderer entityTypeId="datasets" entity={dataset} disableLink />
              ) : (
                <CustomTypePropertyRenderer entityTypeId="datasets" entity={dataset} />
              )}
            </div>
          ),
        },
        ...(!context?.mWebEnabled
          ? [
              {
                key: DatasetFieldLabels.creationDate,
                value: dataset.creationDate ? <DateTimeRenderer date={dataset.creationDate} /> : NotSet,
              },
            ]
          : []),
        {
          key: DatasetFieldLabels.projects,
          value: <GetProjects projects={dataset.projects} createLinks={!context?.viewShared} />,
        }
      );
      setMapping(() => mapping);
      setLoading(() => false);
    }
    // log cleanup
    // TODO: check dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context?.viewShared, dataset]);

  const body = (
    <>
      {loading ? (
        <Skeleton type="pairs" />
      ) : (
        <>
          <div className={styles.container}>
            <Table noPadding nonFoldable>
              <Table.Head>Details</Table.Head>
              <Table.Body>
                <ContentTable content={mapping} />
              </Table.Body>
            </Table>
            {context?.viewShared ? (
              <CustomTypeMinimalRenderer entity={dataset} />
            ) : (
              <CustomTypeRenderer
                entity={dataset}
                includeCustomFieldId={false}
                rowStyle={{ borderBottom: 0 }}
                tableStyle={{ padding: 0, margin: 0, border: 0 }}
              />
            )}
          </div>
        </>
      )}
    </>
  );

  if (!tile) return body;
  return (
    <>
      <Tile>
        {/* <Tile.Head title="Dataset" /> */}
        <Tile.Body style={{ borderTop: "0px" }}>{body}</Tile.Body>
      </Tile>
    </>
  );
};
